export default __webpack_public_path__ + "static/media/SE20.f38975f5.png";